import PropTypes from 'prop-types';

const formSectionsPropType = PropTypes.arrayOf(PropTypes.shape({
  fields: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    selectedType: PropTypes.string,
    configProps: PropTypes.shape({
      title: PropTypes.string,
    }),
  })),
}));

export { formSectionsPropType };
